import { ENDPOINT_MESSAGE_RECEIVED } from '../base/conference/actionTypes';
import MiddlewareRegistry from '../base/redux/MiddlewareRegistry';
import { showNotification } from '../notifications/actions';
import { NOTIFICATION_TIMEOUT_TYPE } from '../notifications/constants';
import { setSlideUrl, setSlideStatus } from './actions';
export const PDF_SLIDE_EVENT_TYPE = 'PDF_SLIDE_URL';
export const SLIDE_STATUS_EVENT_TYPE = 'SLIDE_STATUS';
MiddlewareRegistry.register((store) => (next) => (action) => {
    if (action.type === ENDPOINT_MESSAGE_RECEIVED) {
        const { data } = action;
        console.log('[slide-view] ENDPOINT_MESSAGE_RECEIVED:', JSON.stringify(data));
        if (data?.type === PDF_SLIDE_EVENT_TYPE && typeof data.url === 'string') {
            // kind 未定義の旧サーバーは通常スライド扱い（後方互換）。
            const kind = typeof data.kind === 'string' ? data.kind : 'slide';
            const score = typeof data.score === 'number' ? data.score : undefined;
            console.log('[slide-view] PDF URL received:', data.url, 'kind:', kind);
            store.dispatch(setSlideUrl(data.url, kind, score));
            // 通知するのは AI評価レポート(feedback_report)のみ。通常スライドは無通知。
            if (kind === 'feedback_report') {
                const scoreText = typeof score === 'number' ? `（スコア ${score}/5）` : '';
                store.dispatch(showNotification({
                    title: 'AI評価レポートが届きました',
                    description: `会話の評価レポートが作成されました${scoreText}。スライドを開いて確認できます。`
                }, NOTIFICATION_TIMEOUT_TYPE.LONG));
            }
        }
        else if (data?.type === SLIDE_STATUS_EVENT_TYPE && data.status) {
            console.log('[slide-view] Slide status received:', data.status);
            store.dispatch(setSlideStatus(data.status));
        }
    }
    return next(action);
});
